import React from 'react';
import { Box, Typography } from '@mui/material';
import ResourceInfoPopover from '../../common/ResourceInfoPopover';
import { TruncatedTitle } from '../../common/TruncatedTitle';
import { RESOURCE_LABEL } from '../../common/constants';
import { ShortcutButton } from './ShortcutButton';

function StudyDeckHeader({ deck, cardCounter }) {
  return (
    <Box id="studyDeck__box_header" className="resourceHeader">
      <Box className="resourceTitleGroup">
        <Box className="resourceTitle">
          <TruncatedTitle
            id="studyDeck__text_title"
            variant="h2"
            component="h1"
            name={deck.title}
          />
          <ResourceInfoPopover
            id="studyDeck__button_info"
            name={deck.title}
            nameLabel={RESOURCE_LABEL.FLASHCARD_DECK}
            resources={deck.resources}
            lastEditedBy={deck.lastEditedBy}
          />
        </Box>
      </Box>

      <Box className="resourceActions">
        {cardCounter && (
          <Typography className="cardCounter" id="studyDeck__text_cardCounter">
            <strong>{cardCounter}</strong>/{deck.cards?.length ?? 0}
          </Typography>
        )}
        <ShortcutButton />
      </Box>
    </Box>
  );
}

export default StudyDeckHeader;
